import { parseKeywords, formatKeywords } from './keywordUtils';

export function getUserPreferences(user) {
  if (!user) {
    return {
      tags: [],
      keywordString: '',
      keywordsArray: [],
      legislators: [],
      clusterBy: '',
      hasPreferences: false,
    };
  }

  const tags = user.user_interests
    ? user.user_interests.toLowerCase().split(',').filter(Boolean)
    : [];

  const keywordString = (() => {
    if (!user.user_keywords) return '';
    try {
      return formatKeywords(user.user_keywords.split(','));
    } catch (e) {
      console.error('Error formatting user keywords', e);
      return '';
    }
  })();

  const keywordsArray = keywordString ? parseKeywords(keywordString) : [];

  const legislators = (() => {
    if (!user.user_lawmakers) return [];
    try {
      return JSON.parse(user.user_lawmakers) || [];
    } catch (e) {
      return [];
    }
  })();

  const clusterBy = user.user_cluster_preference || '';

  return {
    tags,
    keywordString,
    keywordsArray,
    legislators,
    clusterBy,
    hasPreferences: Boolean(tags.length || keywordString || legislators.length),
  };
}
